import classNames from 'classnames'
import React from 'react'

import styles from './Button.module.scss'
import { BuyIcon, CheckIcon, CometIcon, CryptoWebIcon, GiftIcon, OpenIcon, Shop, UseIcon } from './icons'

type IconType = 'buy' | 'gift' | 'open' | 'use' | 'crypto' | 'shop' | 'check' | 'comet'

const mapIcon: Record<IconType, React.ComponentType<{ className?: string }>> = {
  buy: BuyIcon,
  gift: GiftIcon,
  open: OpenIcon,
  use: UseIcon,
  crypto: CryptoWebIcon,
  shop: Shop,
  check: CheckIcon,
  comet: CometIcon,
} as const

type Props = {
  onClick: () => void
  children: React.ReactNode
  className?: string
  icon?: keyof typeof mapIcon
  contentAfterDelimiter?: string
  contentWithShadow?: React.ReactNode
  isLoading?: boolean
}

export const Button = ({
  onClick,
  children,
  className,
  icon,
  contentWithShadow,
  isLoading,
}: Props) => {
  const IconComponent = icon ? mapIcon[icon] : null

  const handleClick = () => {
    if (isLoading) {
      return
    }
    onClick()
  }

  return (
    <div
      className={classNames(styles.root, { [styles.loading]: isLoading }, className)}
      onClick={handleClick}
    >
      {IconComponent && <IconComponent className={styles.icon} />}
      {children}
      {contentWithShadow && (
        <span className={styles.contentWithShadow}>{contentWithShadow}</span>
      )}
    </div>
  )
}
